import React, {useEffect} from 'react';
import FormWrapper from './FormWrapper';
import {isFunction, isNil} from 'lodash';
import BtnGroup from 'components/BtnGroup';
import {Box, Button, HStack, Stack, Text, useColorModeValue} from '@chakra-ui/react';
import { useColorModeValueKey } from 'hooks/useColors';

const ButtonSelector = (props) => {
    const {formik, i18n, index, name, disabled, accept, options, label} = props;
    const value = formik.values[name];
    const ops = isFunction(options) ? options(formik.values) : options;
    const currentObj = ops.find((item) => item.value === value);
    const borderColor = useColorModeValueKey('border');
    const primary = useColorModeValueKey('primary')
    useEffect(() => {
        if (isNil(currentObj) || currentObj.disabled) {
            formik.setFieldValue(name, null);
        }
    }, [currentObj]);

    return (
        <FormWrapper {...props}>
            <Stack spacing={2}>
                <HStack  flexWrap={'wrap'}>
                    {ops.map((item) => {
                        return (
                            <Box
                                borderColor={value===item.value ? 'transparent' : borderColor}
                                backgroundColor={value===item.value ? primary : ''}
                                borderWidth={1}
                                py={1}
                                px={3}
                                cursor={'pointer'}
                                _hover={{ bg: value===item.value ? '' : useColorModeValue('gray.100', 'gray.700') }}
                                transition='all 0.2s cubic-bezier(.08,.52,.52,1)'
                                onClick={() => formik.setFieldValue(name, item.value)}
                                variant={'outline'}
                                fontSize={'sm'}
                                fontWeight={400}
                                borderRadius={'md'}
                            >
                                {item.label}
                            </Box>
                        );
                    })}
                </HStack>
            </Stack>
        </FormWrapper>
    );
};

export default ButtonSelector;
